export default "__VITE_ASSET__6eaa8ba5__"